import { GrowthBook } from '@growthbook/growthbook-react';
import { GROWTHBOOK_API_HOST, GROWTHBOOK_CLIENT_KEY } from '../constants/growthBook';

const growthbook: GrowthBook = new GrowthBook({ apiHost: GROWTHBOOK_API_HOST, clientKey: GROWTHBOOK_CLIENT_KEY });

let _growthbookReady = !GROWTHBOOK_CLIENT_KEY;

export const growthbookInitPromise = GROWTHBOOK_CLIENT_KEY
  ? growthbook
      .init()
      .catch((error) => {
        /* eslint-disable no-console */
        console.warn('GrowthBook initialization failed:', error);
      })
      .finally(() => {
        _growthbookReady = true;
      })
  : Promise.resolve().finally(() => {
      _growthbookReady = true;
    });
export const isGrowthbookReady = () => _growthbookReady;

export const getGrowthbookInstance = () => growthbook;

type Nullable<T> = T | null;

export const getGlobalFeatureValue = <T>(featureKey: string, defaultValue: Nullable<T> = null) => {
  const value = growthbook?.getFeatureValue(featureKey, defaultValue);
  if (!value) {
    return defaultValue;
  }
  return value;
};

export const getPrefillConfigFromGB = () => {
  const prefillConfig = getGlobalFeatureValue<{ domain: string; values: { email: string; password: string } }[] | null>(
    'login-form-prefill-config',
    null
  );

  if (prefillConfig) {
    const matched = prefillConfig.find(({ domain }) => window.location.hostname.includes(domain));

    if (matched && matched.values) {
      const { email = '', password = '' } = matched.values;
      return { username: email, email, password };
    }
  }

  const queryParams = new URLSearchParams(window.location.search);
  const email = queryParams.get('username') ?? '';

  return { username: email, email, password: '' };
};
